import Container from '../../atoms/container/playerActionContainer';
import PauseIcon from '../../atoms/icons/pause';
import PlayIcon from '../../atoms/icons/play';
import RewindIcon from '../../atoms/icons/rewind';
import ForwardIcon from '../../atoms/icons/forward';
import Speed from '../../atoms/text/playerActionSpeed';
import { PlayerState } from '../../../../shared/types/enums/player';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import {
  mediaSelector,
  toggle as togglePlayer,
} from '../../../../shared/store/slices/media.slice';

function ProgressBarAction() {
  const dispatch = useAppDispatch();
  const { state, speed } = useAppSelector(mediaSelector);

  let margin = 0;
  let height = 33.3;
  let width = 30;
  let Icon = null;
  switch (state) {
    case PlayerState.PLAY:
    case PlayerState.PLAYING:
      height = 34;
      width = 26;
      Icon = PauseIcon;
      break;
    case PlayerState.SEEKING:
      if (speed === 1) {
        Icon = PlayIcon;
      } else {
        height = 34;
        width = 58;
        margin = speed > 0 ? 12 : 14;
        Icon = speed > 0 ? ForwardIcon : RewindIcon;
      }
      break;
    default:
      Icon = PlayIcon;
      break;
  }

  const multiplier = Math.abs(speed) > 1 ? `X${Math.abs(speed)}` : null;
  return (
    <>
      <Container margin={margin} onClick={() => dispatch(togglePlayer())}>
        <Icon height={height} width={width} />
        <Speed>{multiplier}</Speed>
      </Container>
    </>
  );
}

export default ProgressBarAction;
